/* eslint-disable react/jsx-no-bind */
import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '@constants/colors';
import { Icon, IconButton } from '@mui';
import LoaderIconWrapper from '@shared/loader-icon-wrapper';
import './file-preview.scss';

const FilePreviewHeader = ({
  assetUrl,
  closePreview,
  current,
  downloadUrl,
  fileName,
  total
}) => {
  const printAsset = () => {
    const printWindow = window.open(assetUrl);
    printWindow.print();
  };

  return (
    <div styleName="file-preview-header">
      <div>{fileName}</div>
      <div>{current} / {total}</div>
      <div>
        <IconButton onClick={printAsset} aria-label="Print">
          <Icon color={colors.neutral.white} role="img">print</Icon>
        </IconButton>
        <LoaderIconWrapper>
          <a href={downloadUrl} download>
            <IconButton aria-label="Download">
              <Icon color={colors.neutral.white} role="img">file_download</Icon>
            </IconButton>
          </a>
        </LoaderIconWrapper>
        <IconButton onClick={closePreview} aria-label="Close">
          <Icon color={colors.neutral.white} role="img">close</Icon>
        </IconButton>
      </div>
    </div>
  );
};

FilePreviewHeader.propTypes = {
  assetUrl: PropTypes.string,
  closePreview: PropTypes.func,
  current: PropTypes.number,
  downloadUrl: PropTypes.string,
  fileName: PropTypes.string,
  total: PropTypes.number
};

export default FilePreviewHeader;
